import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportToExcelService {
  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_${formatDate(new Date(), 'yyyy-MM-dd', 'en-US')}.xlsx`;
  }

  private sanitizeWorksheetName(name: string): string {
    // Excel worksheet names cannot contain: * ? : \ / [ ]
    // Also limited to 31 characters
    return name.replace(/[*?:\\/\[\]]/g, '_').substring(0, 31);
  }

  public async exportAsExcelFile(json: any[], excelFileName: string, element?: HTMLElement): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.sanitizeWorksheetName(excelFileName));

    const headers = Object.keys(json[0]);

    // Add header row
    worksheet.addRow(headers);
    // Add data rows
    json.forEach(item => {
      worksheet.addRow(headers.map(key => item[key]))
    })
    // Format header
    worksheet.getRow(1).font = { bold: true };
    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${excelFileName}.xlsx`);
  }

  exportPdf(exportColumns:any, data:any) {
    
    const doc:any = new jsPDF('l','pt','a4');
    
    doc.html(data,{callback: (doc:any) =>{
      doc.save("products.pdf");
    }});
  }
}
